<template>
  <span>
    <span @click.stop="handleOpen">
      <slot></slot>
    </span>
    <el-dialog append-to-body :title="productName" top="15vh" :visible="dialogVisible" width="400px" @close="close">
      <div class="my-text-center my-p-b-20">
        <!-- 网页版 -->
        <h3 class="my-m-t-20 my-font-lg my-font-bold">电脑网页版</h3>
        <div>
          <span>{{ webUrl}}</span>
          <copy-icon :content=" webUrl"></copy-icon>
        </div>
        <div>
          <div @click="openUrl(webUrl)" class="my-m-t-10 btn2" :style="{background:`linear-gradient(306deg,#B2EABF, #74D689)`}">点击登录网页版</div>
        </div>
        <!-- 手机版（小程序） -->
        <h3 class="my-m-t-40 my-font-lg my-font-bold">手机小程序</h3>
        <div class="col-12 col-md-6 col-lg" v-if="softPrice.softXcxQrCodeUrl">
          <div class="down-box">
            <div>
              <img :src="softPrice.softXcxQrCodeUrl" alt width="128" height="128" />
            </div>
            <div class="my-font-xs my-type-info my-m-t-10">微信扫码体验手机版小程序</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </span>
</template> 
          
<script>
// import elDragDialog from '@/directive/el-drag-dialog'

import { mapGetters } from 'vuex'

export default {
  name: '',
  directives: {},
  components: {},
  props: {
    title: {
      type: String,
      default: '免费试用'
    },
    no: {
      type: String,
      default: ''
    },
    amount: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      dialogVisible: false,
      timer: null,
      timeCount: 0,
      text: '',
      loading: true
    }
  },
  computed: {
    ...mapGetters(['softPrice']),
    webUrl() {
      return `https://${this.utils.getProductCode().toLowerCase()}.jiandanke.cn/web`
    },
    productCode() {
      return this.utils.getProductCode()
    },
    productName() {
      return this.utils.getProductName()
    }
  },
  created() {},

  methods: {
    close() {
      clearTimeout(this.timer)
      this.dialogVisible = false
    },
    handleOpen() {
      this.dialogVisible = true
    },
    openUrl(url) {
      let newUrl = url
      if (this.onloadArgs.getInvite()) {
        newUrl = newUrl + `/#/?invite=${this.onloadArgs.getInvite()}`
      }
      window.open(newUrl, '_blank ')
    }
  }
}
</script>
          
<style lang="scss" >
</style>
          